export enum ButtonTypeEnum{
    coloured,
    uncoloured
}